<template>
    <div class="navbar navbar-expand-lg text-muted">
        <span class="navbar-text font-size-xs">
        &copy; {{ currentYear }} <a :href="(topbar.logo && topbar.logo.link ? topbar.logo.link : '#')">{{ (app.name ? app.name : 'APP Title' ) }}</a>
        </span>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { useLayoutHandlerStore } from '@services/pinia/LayoutHandlerStore';

export default {
    name: 'LimitlessPageFooter',
    computed: {
        ...mapState(useLayoutHandlerStore, ['app', 'topbar']),
        currentYear() {
            const date = new Date();
            return date.getFullYear();
        },
    },
};
</script>
